import React from 'react';
import { ButtonProps, Image } from 'antd';
import { ButtonWrapper } from './ProductsFilterButton.styles';

const ProductsFilterButton = (props: ButtonProps) => {
    return (
        <ButtonWrapper {...props} icon={<Image src="src/assets/images/filter-small.svg" preview={false} />}>
            Filter
        </ButtonWrapper>
    );
};

export default ProductsFilterButton;
